// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import * as React from 'react';
import { useSelector } from 'react-redux';

import { HiddenAnnouncementStoreType, hiddenAnnouncementSelector } from './../../store/hiddenAnnouncement';

import Styles from './styles.module.scss';

export default function HiddenAnnouncement() {
    const hiddenAnnouncementState: HiddenAnnouncementStoreType = useSelector(state => hiddenAnnouncementSelector(state));
    return (
        <div className={Styles.screenReaderOnly} role="status" aria-atomic="true" aria-live="assertive">
            {hiddenAnnouncementState.message}
        </div>
    );
}
